const KEY_ENABLED     = 'prvsk_alert_poll_enabled';
const KEY_INTERVAL    = 'prvsk_alert_poll_interval';
const KEY_IDLE_RELOAD = 'prvsk_alert_idle_reload';

const DEFAULTS = { enabled: true, intervalSecs: 60, idleReloadSecs: 300 };

export function getAlertPollConfig() {
  return {
    enabled:        JSON.parse(localStorage.getItem(KEY_ENABLED)     ?? 'true'),
    intervalSecs:   JSON.parse(localStorage.getItem(KEY_INTERVAL)    ?? '60'),
    idleReloadSecs: JSON.parse(localStorage.getItem(KEY_IDLE_RELOAD) ?? '300'),
  };
}

export function setAlertPollConfig({ enabled, intervalSecs, idleReloadSecs }) {
  if (enabled        !== undefined) localStorage.setItem(KEY_ENABLED,     JSON.stringify(enabled));
  if (intervalSecs   !== undefined) localStorage.setItem(KEY_INTERVAL,    JSON.stringify(intervalSecs));
  if (idleReloadSecs !== undefined) localStorage.setItem(KEY_IDLE_RELOAD, JSON.stringify(idleReloadSecs));
}

export function getAlertPollMs() {
  const { enabled, intervalSecs } = getAlertPollConfig();
  return enabled ? Math.max(intervalSecs, 10) * 1000 : 0;
}

export function getIdleReloadMs() {
  const { idleReloadSecs } = getAlertPollConfig();
  return idleReloadSecs > 0 ? Math.max(idleReloadSecs, 30) * 1000 : 0;
}

export { DEFAULTS };

export async function syncAlertPollFromServer(apiFetchFn) {
  try {
    const r = await apiFetchFn('/settings/alert-poll');
    if (!r.ok) return;
    const d = await r.json();
    localStorage.setItem(KEY_ENABLED,     JSON.stringify(d.enabled));
    localStorage.setItem(KEY_INTERVAL,    JSON.stringify(d.intervalSecs));
    localStorage.setItem(KEY_IDLE_RELOAD, JSON.stringify(d.idleReloadSecs));
  } catch { /* silent */ }
}

export async function saveAlertPollToServer(apiFetchFn, config) {
  const r = await apiFetchFn('/settings/alert-poll', {
    method:  'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify(config),
  });
  if (!r.ok) throw new Error('Failed to save alert poll settings');
  const d = await r.json();
  localStorage.setItem(KEY_ENABLED,     JSON.stringify(d.enabled));
  localStorage.setItem(KEY_INTERVAL,    JSON.stringify(d.intervalSecs));
  localStorage.setItem(KEY_IDLE_RELOAD, JSON.stringify(d.idleReloadSecs));
  return d;
}
